import {
    ADD_CONFERENCE, BOOK_CONFERENCE, CANCEL_CONFERENCE_BOOKING, CONFERENCE_BOOKINGS, CONFERENCE_ERROR, DELETE_CONFERENCE_BOOKING, LOAD_CONFERENCE, MY_CONFERENCE_BOOKINGS
} from '../actions/types';

const initialState = {
    conference: null,
    conferences: [],
    bookings: [],
    loading: true,
    error: {}
}

export default function foo(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case CONFERENCE_ERROR:
            return{
                ...state,
                error: payload,
                loading: false,
            };
        case LOAD_CONFERENCE:
            return {
                ...state,
                conferences: payload,
                loading: false,
            };
        case ADD_CONFERENCE:
            return {
                ...state,
                conferences: [payload, ...state.conferences],
                loading: false
            };
        case CONFERENCE_BOOKINGS:
            return {
                ...state,
                bookings: payload,
                loading: false,
            };
        case MY_CONFERENCE_BOOKINGS:
            return {
                ...state,
                bookings: payload,
                loading: false,
            };
        case BOOK_CONFERENCE:
            return {
                ...state,
                bookings: [payload, ...state.bookings],
                loading: false
            };
        case DELETE_CONFERENCE_BOOKING:
            return {
                ...state,
                bookings: state.bookings.filter(booking => booking._id !== payload),
                loading: false
            };
        case CANCEL_CONFERENCE_BOOKING:
            return {
                ...state,
                bookings: state.bookings.map(booking => booking._id === payload._id ? { ...booking, status: payload.status } : booking),
                loading: false
            };
        default:
            return state;
    }
}